import LoginForm from './LoginForm';

export default LoginForm;



// WEBPACK FOOTER //
// ./assets/app/login/components/LoginForm/index.js